import { render, staticRenderFns } from "./epic_item_details.vue?vue&type=template&id=438fb830"
import script from "./epic_item_details.vue?vue&type=script&lang=js"
export * from "./epic_item_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports